const map = {
	"./oeiraseu/default-logo.png": 20324,
	"./oeiraseu/favicon.png": 61129,
	"./oeiraseu/footer-logo - original.png": 83954,
	"./oeiraseu/footer-logo-2.png": 86859,
	"./oeiraseu/footer-logo.png": 25666,
	"./oeiraseu/logo-1.svg": 80249,
	"./oeiraseu/logo-2.svg": 14602,
	"./oeiraseu/logo-3.svg": 83419,
	"./oeiraseu/logo-header-mobile.svg": 85494,
	"./oeiraseu/logo-header-tablet.svg": 25360,
	"./oeiraseu/logo-header.svg": 43143,
	"./oeiraseu/logo-mobile.svg": 92190,
	"./oeiraseu/logo.svg": 80463,
	"./oeiraseu/logo_old.svg": 2009,
	"./oeiraseu/maskable-icon.png": 89171
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68869;